import { connect } from 'react-redux';

import { basketActions } from '../../../../../../weborder/redux';
import { PaymentOptions } from './PaymentOptions';

export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapDispatchToProps = (dispatch) => ({
  selectPayment: (paymentId: string) => {
    dispatch(basketActions.selectPayment({ paymentId }));
  },
});

export default connect(null, mapDispatchToProps)(PaymentOptions);
